import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { colors } from 'Constants/Colors';

const wave1 = keyframes`
  0% {
    transform: translateX(-100%) scale(0.7) translateY(5px);
    border-radius: 40%;
  }
  25% {
    transform: translateX(-50%) scale(0.8) translateY(2px);
    border-radius: 50%;
  }
  50% {
    transform: translateX(0%) scale(0.7) translateY(5px);
    border-radius: 40%;
  }
  75% {
    transform: translateX(50%) scale(0.8) translateY(2px);
    border-radius: 50%;
  }
  100% {
    transform: translateX(100%) scale(0.7) translateY(5px);
    border-radius: 40%;
  }
`;

const wave2 = keyframes`
  0% {
    transform: translateX(100%) scale(0.9) translateY(2px);
    border-radius: 45%;
  }
  25% {
    transform: translateX(50%) scale(1) translateY(-1px);
    border-radius: 55%;
  }
  50% {
    transform: translateX(0%) scale(0.9) translateY(2px);
    border-radius: 45%;
  }
  75% {
    transform: translateX(-50%) scale(1) translateY(-1px);
    border-radius: 55%;
  }
  100% {
    transform: translateX(-100%) scale(0.9) translateY(2px);
    border-radius: 45%;
  }
`;

interface TotalCardContainerProps {
  width?: string;
  fillAnimation?: boolean;
  fillPercentage?: number | string;
}

export const TotalCardContainer = styled.div<TotalCardContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: ${colors.WHITE};
  width: ${({ width }) => width || '150px'};
  height: 100px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition:
    transform 0.2s ease-out,
    box-shadow 0.2s ease-out;
  cursor: pointer;
  will-change: transform, box-shadow;
  position: relative;
  overflow: hidden;

  ${({ fillAnimation, fillPercentage }) =>
    fillAnimation &&
    `
    &:after, &:before {
      content: '';
      position: absolute;
      bottom: 0;
      left: -50%;
      right: -50%;
      width: 200%;
      height: ${fillPercentage}%;
      transition: height 1s ease-in-out;
      z-index: 0;
      transform-origin: center bottom;
    }

    &:before {
      background: linear-gradient(180deg, 
        ${colors.GREEN}4D 0%, 
        ${colors.GREEN}80 50%,
        ${colors.GREEN}B3 100%
      );
      animation: ${wave1} 8s linear infinite;
      z-index: 0;
    }

    &:after {
      background: linear-gradient(180deg, 
        ${colors.GREEN}33 0%, 
        ${colors.GREEN}66 50%,
        ${colors.GREEN}99 100%
      );
      animation: ${wave2} 6s linear infinite;
      z-index: 0;
      opacity: 0.05;
    }
  `}

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  }
`;

export const TotalCardColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  z-index: 1;
`;
